import * as React from 'react'
import { cn } from '@/shared/utils'

export interface TogglePillProps {
  checked: boolean
  onCheckedChange: (checked: boolean) => void
  disabled?: boolean
  className?: string
  'aria-label'?: string
}

/**
 * Sliding toggle switch (Figma design):
 * - Pill-shaped track; light grey (off) / dark (on)
 * - White circular thumb that slides left (off) or right (on)
 */
export const TogglePill = React.forwardRef<HTMLButtonElement, TogglePillProps>(
  (
    {
      checked,
      onCheckedChange,
      disabled = false,
      className,
      'aria-label': ariaLabel
    },
    ref
  ) => {
    return (
      <button
        ref={ref}
        type="button"
        role="switch"
        aria-checked={checked}
        aria-label={ariaLabel}
        disabled={disabled}
        onClick={() => onCheckedChange(!checked)}
        className={cn(
          'relative inline-flex h-6 w-11 shrink-0 rounded-full transition-colors',
          'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2',
          'disabled:cursor-not-allowed disabled:opacity-50',
          checked ? 'bg-adventure-700' : 'bg-earth-200',
          className
        )}
      >
        <span
          className={cn(
            'pointer-events-none absolute top-0.5 left-0.5 h-5 w-5 rounded-full bg-white shadow-sm transition-transform',
            checked ? 'translate-x-5' : 'translate-x-0'
          )}
        />
      </button>
    )
  }
)
TogglePill.displayName = 'TogglePill'
